import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Preloader from '../../../../general/Preloader';
import FormUpdate from './FormUpdate';

const ModalIndex = (props) => {
    const [showEditInfo, setShowEditInfo] = useState(props.user.show_info);
    const [user, setUser] = useState(props.user)
    const token = document.querySelector("[name='csrf-token']").content;
    const [isLoaded, setIsLoaded] = useState(false);
    const [message, setMessage] = useState({
        type: "",
        url: "",
        message: ""
    });

    const form = {
        user_id: props.user.id,
        discount_code_id: props.discount_code ? props.discount_code.id : "",
        affiliate_id: props.affiliate ? props.affiliate.id : "",
        price_id: props.price.id,
        reference: props.reference
    };

    const handleClick = () => {
        setIsLoaded(true)
        fetch(`/api/v1/create_order`, {
            method: 'POST', // or 'PUT'
            body: JSON.stringify(form), // data can be `string` or {object}!
            headers: {
                "X-CSRF-Token": token,
                "Content-Type": "application/json"
            }
        })

        .then(res => res.json())
        .catch(error => console.error("Error:", error))
        .then(data => {
            if(data.type == "success"){
                setMessage(data)
                setIsLoaded(false)
            }else{
                setMessage(data)
                setIsLoaded(false)
            }
        });
    }

    const updateStatus = (status) => {
        setShowEditInfo(status)
    }

    const updateStateUser = (user) => {
        setUser(user)
    }

    return (
        <React.Fragment>
            <Modal isOpen={props.modal} toggle={props.toggle} className="modal-dialog-centered" backdrop={props.backdrop}>
                <ModalBody>
                    <div className="row modal-wompi">
                        <div className="col-md-12 text-center mb-4">
                            <img src="https://statics.addi.com/logo/v2/main/addi-logo.svg" height={60} alt="" />
                        </div>
                        
                        {!showEditInfo && (
                            <div className="col-md-12 text-center mb-3">
                                <h5 className='text-dark'>Con la siguiente información procederemos con el pago. Por favor, revisa los datos y confirma que todo esté correcto antes de continuar.</h5>

                                <hr />
                            </div>
                        )}


                        <div className="col-md-12">
                            {showEditInfo && (
                                <FormUpdate 
                                    closeModal={props.toggle}
                                    updateStatus={updateStatus}
                                    updateStateUser={updateStateUser}
                                />
                            )}

                            {!showEditInfo && (
                                <React.Fragment>
                                    {!isLoaded ? (
                                        <React.Fragment>
                                            {message.type == "" ? (
                                                <div className="row">
                                                    <div className="col-md-4">
                                                        <strong className='label-user-info'>Nombre</strong>
                                                        <p className='text-dark'>{user.name}</p>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <strong className='label-user-info'>Apellido</strong>
                                                        <p className='text-dark'>{user.lastnames}</p>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <strong className='label-user-info'>Numero de telefono</strong>
                                                        <p className='text-dark'>{user.phone}</p>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <hr />
                                                    </div>

                                                    <div className="col-md-4">
                                                        <strong className='label-user-info'>Documento</strong>
                                                        <p className='text-dark'>{user.document}</p>
                                                    </div>

                                                    <div className="col-md-4">
                                                        <strong className='label-user-info'>Correo</strong>
                                                        <p className='text-dark'>{user.email}</p>
                                                    </div>

                                                    <div className="col-md-12">
                                                        <hr />
                                                    </div>

                                                    <div className="col-md-12 text-center">
                                                        <button className='btn btn-primary text-white mr-2 text-capitalize' onClick={() => handleClick()}>
                                                            <i className="fa fa-shopping-cart mr-2" aria-hidden="true"></i> Continuar con el pago
                                                        </button>

                                                        <button className='btn btn-danger text-white text-capitalize' onClick={() => props.toggle()}>
                                                            Cancelar
                                                        </button>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div className={`alert alert-${message.type} text-center text-dark`} role="alert">
                                                    <h4>{message.message}</h4>
                                                    <hr />
                                                    {message.url && (
                                                        <React.Fragment>
                                                            <a 
                                                                href={message.url} 
                                                                target='_blank'
                                                                className={`btn btn-addi mr-2`}
                                                            >
                                                                Continuar con la compra
                                                            </a>

                                                            <button className='btn btn-danger text-white' onClick={() => props.toggle()}>
                                                                Cerrar
                                                            </button>
                                                        </React.Fragment>
                                                    )}
                                                </div>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        <div className="text-center">
                                            <Preloader/>
                                        </div>
                                    )}
                                </React.Fragment>   
                            )}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
}


export default ModalIndex;

